export default __webpack_public_path__ + "static/media/create-complete.b2686cba.svg";